import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import Title from './Title';
import AppBank from './AppBank';
//import {Tools} from './Tools';
import {Inc,Dataset,ItemSearchCondition,SortOption} from './Inc';

interface Props {
    pages:Dataset[],
	useUpack?:boolean,
    update(cond:ItemSearchCondition,page:number): void,
	bankKey?:string,
	bank?:AppBank,
}

const ItemListSearch = (props:Props)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultItemSearchCondition());
	//const keyBank = "savedIitemSearchCondition";

    const update = ()=>{
        if ( props.bank && props.bankKey ) {
		    props.bank.set(props.bankKey,JSON.stringify(states));
        }
        props.update(states,1);
    }
	const handleChange = (name: keyof ItemSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, [name]: event.target.value });
	};
	const handleChangeSelect = (name: keyof ItemSearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeOption = (name: keyof SortOption) => (event: SelectChangeEvent) => {
        let option = states.option;
        option[name] = event.target.value;
		setStates({ ...states, "option": option});
    };
	const resetCondition = ()=>{
		setStates(Inc.defaultItemSearchCondition());
    }
	const handleChangeCheckboxes = (name: keyof ItemSearchCondition,index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
		let boolList:boolean[] = [];
		let idList:string[] = [];
		let blName:string = "";
		let datas:Dataset[] = [];
		if( name==="sample_ids" ){
			boolList = states.sample_bls;
			blName = "sample_bls";
			datas = Inc.exists;
        }
		if( name==="stock_ids" ){
			boolList = states.stock_bls;
			blName = "stock_bls";
			datas = Inc.exists;
		}
        
        if( blName!=="" ){
			if( event.target.checked ){
				boolList[index] = true;
			} else {
				boolList[index] = false;
			}
			for( let i=0 ; i<boolList.length ; i++ ){
				if( boolList[i] ){
					idList.push( datas[i].id );
				}
			}
			setStates({ ...states, [blName]: boolList, [name]: idList });
		}
	};

    const checkboxes = (id:keyof ItemSearchCondition,list:Dataset[])=>{
		const tmp = list.map( (data:Dataset,index:number)=>{
			const key = id+index;
			let v:boolean = false;
			if( id==="sample_ids" ){
				v = states.sample_bls[index];
            }
			if( id==="stock_ids" ){
				v = states.stock_bls[index];
			}
            
			return (
				<FormControlLabel
			    	key={key}
					control={
					<Checkbox
						checked={v}
						onChange={handleChangeCheckboxes(id,index)}
						value={String(data.id)}
						color="primary"
						className={classes.checkbox}
					/>
					}
					label={data.label}
				/>
			);
		});
		return (
			<div className={classes.checkboxes}>
				{tmp}
			</div>
		)
    };
    
    useEffect( ()=>{
		if( props.bank && props.bankKey && props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[]);
    
    //const years = Tools.getSelectYears();
    //const months = Tools.getSelectMonths();
    const orders:Dataset[] = [
        {
            id:"item_id",
            label:"商品ID",
        },
        {
            id:"item_name",
            label:"商品名",
        },
        {
            id:"page_name",
            label:"シリーズ名",
        },
    ]

    //console.log("stock::list::search");
	
	return (
		<div id="stock_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品名</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_name}
							variant="standard"
                            onChange={handleChange("item_name")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>シリーズ</FormLabel>
                        <Select
                            value={states.page_id}
                            onChange={handleChangeSelect('page_id')}
                            inputProps={{
                                name: 'page_id',
                                id: 'page_id-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            <MenuItem key="page_id" value="">　</MenuItem>
                            {props.pages.map((option:Dataset,index:number) => {
                                const key = "pageid"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>状態表示</FormLabel>
                        
                        <Select
                            value={states.status}
                            onChange={handleChangeSelect('status')}
                            inputProps={{
                                name: 'status',
                                id: 'status-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            <MenuItem key="status0" value="">　</MenuItem>
                            {Inc.itemStatus.map((option:Dataset,index:number) => {
                                const key = "status"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
				{props.useUpack &&
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>配送方法</FormLabel>
                        
                        <Select
                            value={states.upack}
                            onChange={handleChangeSelect('upack')}
                            inputProps={{
                                name: 'upack_flag',
                                id: 'upack_flag-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            <MenuItem key="upack_flag" value="">　</MenuItem>
                            {Inc.itemUpack.map((option:Dataset,index:number) => {
                                const key = "upack_flag"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
				}
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>チャリティ</FormLabel>
                        
                        <Select
                            value={states.charity_flag}
                            onChange={handleChangeSelect('charity_flag')}
                            inputProps={{
                                name: 'charity_flag',
                                id: 'charity_flag-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            <MenuItem key="charity_flag" value="">　</MenuItem>
                            {Inc.charitys.map((option:Dataset,index:number) => {
                                const key = "charity_flag"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>


                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>在庫の有無</FormLabel>
                        <FormGroup>
                            {checkboxes("stock_ids",Inc.exists)}
                        </FormGroup>
                    </FormControl>
                </Grid>

                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示基準</FormLabel>
                        
                        <Select
                            value={states.option.order}
                            onChange={handleChangeOption('order')}
                            inputProps={{
                                name: 'order',
                                id: 'order-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            {orders.map((option:Dataset,index:number) => {
                                const key = "order"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示順</FormLabel>
                        
                        <Select
                            value={states.option.sort}
                            onChange={handleChangeOption('sort')}
                            inputProps={{
                                name: 'sort',
                                id: 'sort-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            {Inc.sorts.map((option:Dataset,index:number) => {
                                const key = "sort"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={12} lg={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示件数</FormLabel>
                        
                        <Select
                            value={states.option.per_page}
                            onChange={handleChangeOption('per_page')}
                            inputProps={{
                                name: 'per_page',
                                id: 'per_page-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            {Inc.perPages.map((option:Dataset,index:number) => {
                                const key = "per_page"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default ItemListSearch;
